import { isPreviewLang, type PreviewLang } from './data';

/**
 * Имя iframe ролика кабинета: по нему кабинет внутри включает заглушку API.
 * Локаль ролика едет в том же имени: `lovestoria-cabinet-preview:ru-ru`.
 */
export const PREVIEW_FRAME = 'lovestoria-cabinet-preview';

export const previewFrameName = (lang: PreviewLang) => `${PREVIEW_FRAME}:${lang}`;

export const isPreviewFrame = () => typeof window !== 'undefined' && window.name.startsWith(`${PREVIEW_FRAME}:`);

export const previewFrameLang = (): PreviewLang => {
  const id = window.name.slice(PREVIEW_FRAME.length + 1);
  return isPreviewLang(id) ? id : 'ru';
};
